export type LutCategory = {
    id: string;
    label: string;
    keywords: string[];
    luts: { id: string; name: string }[];
};

export const LUT_CATEGORIES: LutCategory[] = [
    {
        id: 'vintage',
        label: 'Creamy Vintage / Faded Film',
        keywords: ['faded', 'film', 'vintage', 'matte'],
        luts: [
            { id: 'Arabica_12_e7cabb.CUBE', name: 'Arabica' },
            { id: 'Bourbon_64_wjtxex.CUBE', name: 'Bourbon' },
            { id: 'Cobi_3_fukrwt.CUBE', name: 'Cobi' },
            { id: 'Cubicle_99_ppohrm.CUBE', name: 'Cubicle' },
            { id: 'Faded_47_uprcjh.CUBE', name: 'Faded' },
            { id: 'Folger_50_dakvrb.CUBE', name: 'Folger' },
            { id: 'Milo_5_jgliei.CUBE', name: 'Milo' },
            { id: 'Paladin_1875_mtlqz5.CUBE', name: 'Paladin' },
            { id: 'Tweed_71_mqsy2c.CUBE', name: 'Tweed' },
            { id: 'Zeke_39_u21k0p.CUBE', name: 'Zeke' }
        ]
    },
    {
        id: 'cinematic',
        label: 'Cinematic Teal & Orange',
        keywords: ['cinematic', 'teal orange', 'dramatic'],
        luts: [
            { id: 'Byers_11_nf1jbp.CUBE', name: 'Byers' },
            { id: 'Django_25_sguqf2.CUBE', name: 'Django' },
            { id: 'McKinnon_75_np9u0y.CUBE', name: 'McKinnon' },
            { id: 'Pitaya_15_ijvunf.CUBE', name: 'Pitaya' },
            { id: 'Sprocket_231_kqewr9.CUBE', name: 'Sprocket' }
        ]
    },
    {
        id: 'modern',
        label: 'Cool & Hard / Modern Commercial',
        keywords: ['clean', 'cool', 'contrast'],
        luts: [
            { id: 'Ava_614_ci3bxz.CUBE', name: 'Ava' },
            { id: 'Azrael_93_jznr13.CUBE', name: 'Azrael' },
            { id: 'Clouseau_54_wjl6ro.CUBE', name: 'Clouseau' },
            { id: 'Contrail_35_lymyg3.CUBE', name: 'Contrail' },
            { id: 'Pasadena_21_otctde.CUBE', name: 'Pasadena' },
            { id: 'Vireo_37_djgxfi.CUBE', name: 'Vireo' }
        ]
    },
    {
        id: 'natural',
        label: 'Natural Balance / General Base',
        keywords: ['neutral', 'base', 'balanced'],
        luts: [
            { id: 'Chemical_168_chnr2v.CUBE', name: 'Chemical' },
            { id: 'Fusion_88_rk0a8r.CUBE', name: 'Fusion' },
            { id: 'Hyla_68_cxlidw.CUBE', name: 'Hyla' },
            { id: 'Korben_214_uu4ad3.CUBE', name: 'Korben' },
            { id: 'Lucky_64_mau1vh.CUBE', name: 'Lucky' },
            { id: 'Reeve_38_k12trl.CUBE', name: 'Reeve' },
            { id: 'Remy_24_bjubkl.CUBE', name: 'Remy' },
            { id: 'Zed_32_das5cq.CUBE', name: 'Zed' }
        ]
    },
    {
        id: 'vivid',
        label: 'High Saturation / Commercial Pop',
        keywords: ['vivid', 'commercial', 'pop'],
        luts: [
            { id: 'Lenox_340_xu9o1w.CUBE', name: 'Lenox' },
            { id: 'Teigen_28_p1uz77.CUBE', name: 'Teigen' }
        ]
    },
    {
        id: 'cyberpunk',
        label: 'Night Neon / Cyberpunk',
        keywords: ['neon', 'night', 'cyberpunk'],
        luts: [
            { id: 'Neon_770_hvbthp.CUBE', name: 'Neon' }
        ]
    },
    {
        id: 'mono',
        label: 'Black & White / Desaturated Art',
        keywords: ['monochrome', 'bw', 'art'],
        luts: [
            { id: 'Clayton_33_uq3eou.CUBE', name: 'Clayton' }
        ]
    },
    {
        id: 'soft_cinematic',
        label: 'Soft Cinematic / Restrained Storytelling',
        keywords: ['soft cinematic', 'storytelling'],
        luts: [
            { id: 'Domingo_145_gsfc6p.CUBE', name: 'Domingo' },
            { id: 'Trent_18_voozrr.CUBE', name: 'Trent' }
        ]
    }
];

export type LutParams = {
    lut_name: string;
    intensity: number;
    source_image_url?: string;
};

export const DEFAULT_LUT_PARAMS: LutParams = {
    lut_name: 'Chemical_168_chnr2v.CUBE',
    intensity: 1.0,
};

export function normalizeLutParams(params: unknown): {
    params: LutParams;
    needsHydrate: boolean;
} {
    const p = params as Partial<LutParams>;
    return {
        params: {
            lut_name: typeof p.lut_name === 'string' ? p.lut_name : DEFAULT_LUT_PARAMS.lut_name,
            intensity: typeof p.intensity === 'number' ? p.intensity : 1.0,
            source_image_url: typeof p.source_image_url === 'string' ? p.source_image_url : undefined,
        },
        needsHydrate: false,
    };
}
